import React from 'react';
import { SoundEffectsContext } from './context';

export const useSoundEffectsController = () => React.useContext(SoundEffectsContext);
export default useSoundEffectsController;
